import { render, staticRenderFns } from "./qc_report.vue?vue&type=template&id=0740c1fa&scoped=true&"
import script from "./qc_report.vue?vue&type=script&lang=js&"
export * from "./qc_report.vue?vue&type=script&lang=js&"
import style0 from "./qc_report.vue?vue&type=style&index=0&id=0740c1fa&scoped=true&lang=less&"
import style1 from "./qc_report.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0740c1fa",
  null
  
)

export default component.exports